import { Reducer } from 'redux';
import { MovimentacoesState, MovimentacoesTypes } from './types';

const INITIAL_STATE: MovimentacoesState = {
  data: [],
  error: false,
  loading: false,
  filter: undefined,
  sorter: undefined,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
  ordenacao: {
    sortBy: '',
    ascendance: '',
  },
  etapa: [],
  etapaloading: false,
  itensNotaEntrada: [],
  etapaerror: false,
};

const reducer: Reducer<MovimentacoesState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MovimentacoesTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MovimentacoesTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
        ordenacao: action.payload.ordenacao,
      };
    case MovimentacoesTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case MovimentacoesTypes.ETAPA_REQUEST:
      return {
        ...state,
        etapaloading: true,
      };
    case MovimentacoesTypes.ETAPA_SUCCESS:
      return {
        ...state,
        etapaloading: false,
        etapaerror: false,
        etapa: action.payload.data,
      };
    case MovimentacoesTypes.ETAPA_FAILURE:
      return {
        ...state,
        etapaloading: false,
        etapaerror: true,
        etapa: [],
      };
    case MovimentacoesTypes.ITENS_NOTA_REQUEST_ENTRADA:
      return {
        ...state,
        loading: true,
      };
    case MovimentacoesTypes.ITENS_NOTA_SUCCESS_ENTRADA:
      return {
        ...state,
        loading: false,
        error: false,
        itensNotaEntrada: action.payload.itensNotaEntrada,
      };
    case MovimentacoesTypes.ITENS_NOTA_FAILURE_ENTRADA:
      return {
        ...state,
        loading: false,
        error: true,
        itensNotaEntrada: [],
      };
    case MovimentacoesTypes.CLEAN_DETALHES_ITENS_NOTA:
      return {
        ...state,
        loading: false,
        error: false,
        itensNotaEntrada: [],
      };
    case MovimentacoesTypes.FILTER_Movimentacoes:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case MovimentacoesTypes.SORTER_Movimentacoes:
      return {
        ...state,
        sorter: action.payload.sorter,
      };
    case MovimentacoesTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
